import { Grid, TextField, IconButton, InputAdornment } from '@mui/material'
import { useState } from 'react'
import { Visibility, VisibilityOff } from '@mui/icons-material'
import ModalRequest from '../../components/ModalRequest'
import axiosInstance from '../../config/axiosConfig'
import { urlConfig } from '../../config/apiConfig'

export default function ModalResetPw({
    open,
    setOpen,
    row,
    getUser,
    handleAlert,
    isCancel,
    setResetPw,
    newPassword,
}) {
    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [showPassword, setShowPassword] = useState(false)
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)

    const handlePasswordChange = (e) => {
        setPassword(e.target.value)
        setError('')
    }

    const handleConfirmPasswordChange = (e) => {
        setConfirmPassword(e.target.value)
        setError('')
    }

    const toggleShowPassword = () => {
        setShowPassword((prev) => !prev)
    }

    const handleSubmit = async () => {
        if (!password || password.length < 8) {
            setError('Password must be at least 8 characters long.')
            return
        }
        if (password !== confirmPassword) {
            setError('Passwords do not match.')
            return
        }

        try {
            setLoading(true)
            await axiosInstance.put(`${urlConfig.reset_pw}/${row.user_id}`, {
                password: password,
                set_new_pwd: true,
            })
            getUser(true)
            setPassword('')
            setConfirmPassword('')
            setShowPassword(false)
            setOpen(false)
            handleAlert('Reset password successfully.', 'success')
        } catch (err) {
            handleAlert(
                `${'Failed to Reset password' || 'Something went wrong.'}`,
                'error',
            )
        } finally {
            setError('')
            setLoading(false)
        }
    }

    const handleCancel = async () => {
        setLoading(true)
        try {
            await axiosInstance.put(`${urlConfig.reset_pw}/${row.user_id}`, {
                set_new_pwd: false,
            })
            getUser()
            setResetPw(false)
            setOpen(false)
            handleAlert('Disable password reset successfully.', 'success')
        } catch (err) {
            handleAlert(
                `${
                    'Failed to disable password reset' ||
                    'Something went wrong.'
                }`,
                'error',
            )
        }
        setLoading(false)
    }

    return (
        <ModalRequest
            disabled={loading}
            open={open}
            setOpen={newPassword ? null : setOpen}
            title={!isCancel ? `New Password` : `Disable Password Reset`}
            width='600px'
            onSubmit={!isCancel ? handleSubmit : handleCancel}
        >
            {!isCancel ? (
                <>
                    <Grid item xs={12}>
                        Users must reset their password when logging in with
                        this password.
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            required
                            size='small'
                            fullWidth
                            label='New Password'
                            type={showPassword ? 'text' : 'password'}
                            variant='outlined'
                            value={password}
                            onChange={handlePasswordChange}
                            error={!!error}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position='end'>
                                        <IconButton
                                            onClick={toggleShowPassword}
                                            edge='end'
                                        >
                                            {showPassword ? (
                                                <VisibilityOff />
                                            ) : (
                                                <Visibility />
                                            )}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            required
                            size='small'
                            fullWidth
                            label='Confirm Password'
                            type={showPassword ? 'text' : 'password'}
                            variant='outlined'
                            value={confirmPassword}
                            onChange={handleConfirmPasswordChange}
                            error={!!error}
                            helperText={error}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position='end'>
                                        <IconButton
                                            onClick={toggleShowPassword}
                                            edge='end'
                                        >
                                            {showPassword ? (
                                                <VisibilityOff />
                                            ) : (
                                                <Visibility />
                                            )}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Grid>
                </>
            ) : (
                <>
                    <Grid item xs={12}>
                        The password will not be changed if you disable the
                        password reset.
                    </Grid>
                </>
            )}
        </ModalRequest>
    )
}
